import { Mail } from "@landvoice/icons";
import DetailsField from "../SearchListings/DetailsField";
import Socials from "../common/Socials";
import SectionHeader from "./SectionHeader";
import { HDivider } from "../common/PropertySummary";
import { OwnerContactInfo } from "src/types/listing";

export default function OwnerInformation({
  owner,
}: {
  owner: OwnerContactInfo;
}) {
  const { fullName, email, address, socials } = owner || {};
  const { formattedAddress = "" } = address || {};

  return (
    <div className="w-full">
      <SectionHeader title="Owner Information" />
      <div className="grid grid-cols-1  md:grid-cols-2 gap-3">
        <DetailsField
          fieldLabel="Name"
          fieldValue={fullName}
          noValueDisplay="No Information found"
        />
        <DetailsField fieldLabel="Address" fieldValue={formattedAddress} />
        <div className="flex flex-col">
          <p className=" font-semibold text-[14px] leading-5 text-gray-secondary ">
            Email and Socials
          </p>
          <div className="flex gap-3 items-center">
            <Mail className="text-[16px]" />{" "}
            {email ? (
              <p className="  text-[14px] leading-5 text-gray-primary ">{email}</p>
            ) : (
              <p className="  text-[14px] leading-5 text-gray-primary italic">
                No email found
              </p>
            )}
          </div>
          {socials && Object.keys(socials).length > 0 && (
            <div className="mt-2">
              <HDivider />
              <div className="h-4 mt-2 flex gap-[14px]">
                <Socials {...socials} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
